import type { JobReport, TypeReport } from "./report.types"

export const isIssueSummaryReport = (type: TypeReport) =>
  type === "REPORT_TYPE_ISSUE_SUMMARY"

export const isScopeSummaryReport = (type: TypeReport) =>
  type === "REPORT_TYPE_SCOPE_SUMMARY"

export const isReportJobSuccess = (report: JobReport) =>
  report.status === "REPORT_JOB_STATUS_SUCCESS"

export const isReportJobRunning = (report: JobReport) =>
  report.status === "REPORT_JOB_STATUS_RUNNING"

export const isReportJobFailed = (report: JobReport) =>
  report.status === "REPORT_JOB_STATUS_FAILED"
